import { type Component } from "solid-js"
import { type OfferingProps } from "../shared/offering-props"

const WebinarPurchaseButtonB: Component<OfferingProps & { fullWidth?: boolean }> = ({ showCheckout, fullWidth }) => {
  return (
    <button onClick={showCheckout} class={`btn--gradient flex items-center justify-center cursor-pointer font-semibold text-base leading-6 text-white whitespace-nowrap duration-200 px-6 py-4${fullWidth ? ' w-full' : ''}`}>
      Get Exclusive Offer Now
    </button>
  )
}

export default WebinarPurchaseButtonB
